import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Notification } from 'src/app/ViewModel/notification';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private getNotificationURL = environment.WEBAPIURL + 'notification/notifications';
  private getNotificationCountUrl = environment.WEBAPIURL + 'notification/notification-count';
  private getNotificationMarkAsReadUrl = environment.WEBAPIURL + 'notification/notifications-mark-as-read/';

  constructor(private _http: HttpClient, private _helperService: HelperService) {
  }
  
  GetAllNotifications(loggedUserId) {
    let params = new HttpParams().set('loginId', loggedUserId);
    return this._http.get<Notification[]>(this.getNotificationURL, { params: params });
  }

  GetNotification(loggedUserId, startIndex, endIndex, filterText) {
    let escapedFilteredText = this._helperService.EscapeSpecialCharacters(filterText);
    let params = new HttpParams()
      .set('loginId', loggedUserId)
      .set('startIndex', startIndex.toString())
      .set('endIndex', endIndex.toString())
      .set('filter', escapedFilteredText);
    return this._http.get<Notification[]>(this.getNotificationURL, { params: params });
  }


  GetNotificationCount(loggedUserId) {
    let params = new HttpParams().set('loggedUserId', loggedUserId);
    return this._http.get<string>(this.getNotificationCountUrl, { params: params });
  }

  SetNotificationMarkAsRead(permitId, loggedUserId) {
    let params = new HttpParams()
      .set('permitId', permitId.toString())
      .set('loggedUserId', loggedUserId);
    return this._http.put(this.getNotificationMarkAsReadUrl, null, { params: params, observe: 'response' });
  }

}
